import React, { useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { GenericFormPage } from '../../../components/generic';
import {
  buildCrewLookupModuleConfig,
  getInitialFormData,
  mapItemToFormData,
  type CrewLookupRouteOptions,
} from './config';
import { CrewLookupKindContext, useCrewLookupKind } from './CrewLookupKindContext';
import { getCrewLookupDef, type CrewLookupDef } from './registry';
import { useCrewLookupItem, type CrewLookupItem } from './useData';

function useCrewLookupFormData(id: number) {
  return useCrewLookupItem(useCrewLookupKind(), id);
}

const FormInner: React.FC<{ def: CrewLookupDef; routes?: CrewLookupRouteOptions }> = ({ def, routes }) => {
  const moduleConfig = useMemo(() => buildCrewLookupModuleConfig(def, routes), [def, routes]);

  return (
    <CrewLookupKindContext.Provider value={def.kind}>
      <GenericFormPage<CrewLookupItem>
        useData={useCrewLookupFormData as any}
        config={{
          ...moduleConfig,
          getInitialFormData: () => getInitialFormData(def),
          mapItemToFormData,
        } as any}
      />
    </CrewLookupKindContext.Provider>
  );
};

const Form: React.FC<{ kind?: string; routes?: CrewLookupRouteOptions }> = ({ kind: kindProp, routes }) => {
  const { kind: kindParam } = useParams<{ kind: string }>();
  const def = getCrewLookupDef(kindProp ?? kindParam);
  if (!def) return <Navigate to="/parameters/countries" replace />;
  return <FormInner def={def} routes={routes} />;
};

export default Form;
